import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Schools from "../Schools";
import SchoolFormDialog from "../Schools/SchoolFormDialog";
import { useLocation } from "react-router-dom";
import axiosInstance from "../../Api/axios.instance";
import { getClusters } from "./Clusters";
import useSession from "../../CustomHooks/useSession";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function ClusterDetails() {
  const [value, setValue] = React.useState(0);
  const [schools, setSchools] = React.useState([]);
  const [clusters, setClusters] = useState([]);
  const { state } = useLocation();
  const { role } = useSession();

  const roleObj = role ? JSON.parse(role) : null;
  const roleName = roleObj?.RoleName;
  const isAdminActive = roleName === "Admin Role - Active";

  const [openForm, setOpenForm] = useState(false);
  const [editingSchool, setEditingSchool] = useState(null);
  const [loadingSchools, setLoadingSchools] = useState(true);

  const regionId = state?.clusters?.RegionId;

  // const _fetchSchools = async () => {
  //   try {
  //     const { data, status } = await axiosInstance.get("/schools/all");
  //     if (status === 200) {
  //       setSchools(data.data.filter((s) => s.RegionId === regionId));
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const _fetchClusters = async () => {
    try {
      const response = await getClusters();
      setClusters(response.data);
    } catch (error) {
      console.log(error);
    }
  };
  const _fetchSchools = async () => {
    try {
      const { data, status } = await axiosInstance.get("/schools/all");
      if (status === 200) {
        setSchools(data.data.filter((s) => s.RegionId === regionId));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingSchools(false);
    }
  };

  // useEffect(() => {
  //   setSchools(state?.clusters?.School || []);
  //   _fetchClusters();
  //   _fetchSchools();
  // }, []);

  useEffect(() => {
    _fetchClusters();
    _fetchSchools();
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleAddSchool = () => {
    setEditingSchool(null);
    setOpenForm(true);
  };

  const handleEditSchool = (school) => {
    setEditingSchool(school);
    setOpenForm(true);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Schools" {...a11yProps(0)} />
        </Tabs>
      </Box>
      {/* <TabPanel value={value} index={0}>
        <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
          <Button variant="contained" onClick={handleAddSchool}>
            Add New School
          </Button>
        </Box>
        <Schools
          schools={schools}
          onSchoolChanged={_fetchSchools}
          onEditSchool={handleEditSchool}
        />
      </TabPanel> */}
      <TabPanel value={value} index={0}>
        {isAdminActive && (
          <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
            <Button variant="contained" onClick={handleAddSchool}>
              Add New School
            </Button>
          </Box>
        )}
        {loadingSchools ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Schools
            schools={schools}
            onSchoolChanged={_fetchSchools}
            onEditSchool={handleEditSchool}
            isAdminActive={isAdminActive}
          />
        )}
      </TabPanel>

      <SchoolFormDialog
        open={openForm}
        onClose={() => setOpenForm(false)}
        onSaved={_fetchSchools}
        clusters={clusters}
        editingSchool={editingSchool}
        defaultRegionId={regionId}
      />
    </Box>
  );
}
